<script>
export default {
    name: 'GeneralInfo',
    props: {
        model: {
            type: Object,
            default: () => {},
        },
        sm: Boolean,
    },
    computed: {
        deliveryInfo() {
            return this.model?.delivery
        },
        price() {
            return this.deliveryInfo?.price
                ? this.$options.filters.toCurrency(
                      this.deliveryInfo?.price,
                      this.locale,
                      this.currency
                  )
                : 0
        },
        minimumOrder() {
            return this.deliveryInfo?.minimum_order_value
                ? this.$options.filters.toCurrency(
                      this.deliveryInfo?.minimum_order_value,
                      this.locale,
                      this.currency
                  )
                : 0
        },
        locale() {
            return this.model?.country?.locale
        },
        currency() {
            return this.model?.country?.currency_code
        },
    },
}
</script>

<template lang="pug">
span.general-info.text-73(:class="sm ? 'text-sm': 'text-m'")
    template(v-if="price") {{ $t('restaurant.delivery_price', {price: price}) }}
    template(v-else) {{ $t('restaurant.free_delivery') }}
    span.mx-2.text-73(:class="sm ? 'text-sm': 'text-m'") •
    template(v-if="minimumOrder") {{ $t('restaurant.minimum_order', {price: minimumOrder}) }}
    template(v-else) {{ $t('restaurant.no_minimum') }}
</template>
